(function ($) {
	
	function setCookie(key, value) {
		var expires = new Date();
		expires.setTime(expires.getTime() + 36000000); //1hour 
		document.cookie = key + '=' + value + ';expires=' + expires.toUTCString()+';path=/';
	}
	function getCookie(key) {
		var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
		return keyValue ? keyValue[2] : null;
	}
    
    $('.accordionH3').click(function(){
        if($(this).hasClass('active')){
            //$(this).next('.panel').slideUp();
            $(this).removeClass('active');
            $(this).parent().removeClass('active');            
        } else {
            //$(this).next('.panel').slideDown();
            $(this).addClass('active');
            $(this).parent().addClass('active');
        }
	});
    
	$('.acordRTop').click(function(){
		var _parent_div = $(this).parent().closest('.accordionContainer');
        _parent_div.removeClass('active');		
        _parent_div.children('.accordionH3').removeClass('active');
	});

	function isValidEmailAddress(emailAddress) {
		var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
		return pattern.test(emailAddress);
	}
    
	//for contact page
	$(document).on('submit', '#contactForm', function(e) {
		var errors = 5;
		var firstname = $('#contactForm input[name=cfirstname]').val().trim();
		if(firstname.length > 0){
			errors = errors - 1;			
			$('#contactForm input[name=cfirstname]').css('border','1px solid rgba(0,0,0,.15)');
            $('.error-msg[data-error-of="cfirstname"]').fadeOut();
		} else{
			$('#contactForm input[name=cfirstname]').css('border','1px solid #fe2851');
			$('.error-msg[data-error-of="cfirstname"]').fadeIn();
		}
		
		var lastname = $('#contactForm input[name=clastname]').val().trim();
		if(lastname.length > 0){
			errors = errors - 1;			
			$('#contactForm input[name=clastname]').css('border','1px solid rgba(0,0,0,.15)');
            $('.error-msg[data-error-of="clastname"]').fadeOut();
		} else{
			$('#contactForm input[name=clastname]').css('border','1px solid #fe2851');
            $('.error-msg[data-error-of="clastname"]').fadeIn();
		}
		
		var email = $('#contactForm input[name=cemail]').val().trim();
		if( email && isValidEmailAddress( email ) ) {
			errors = errors -1;			
			$('#contactForm input[name=cemail]').css('border','1px solid rgba(0,0,0,.15)');
            $('.error-msg[data-error-of="cemail"]').fadeOut();
		} else{
			$('#contactForm input[name=cemail]').css('border','1px solid #fe2851');
            $('.error-msg[data-error-of="cemail"]').fadeIn();
        }
		
        var phonenumber = $('#contactForm input[name=cphonenumber]').val().trim();
        var numbers = /^\d+((;\d+)*|-\d+)?$/;
        var isValid = phonenumber.match(/^[\s\d+(-\d+]*$/);
        if(isValid){
            errors = errors -1;
            $('#contactForm input[name=cphonenumber]').css('border','1px solid rgba(0,0,0,.15)');            
        }else {
			$('#contactForm input[name=cphonenumber]').css('border','1px solid #fe2851');
        }
        
        var inquiryContent = $('#contactForm textarea[name=cinquiryContent]').val().trim();
        if(inquiryContent.length > 0){
			errors = errors -1;			
			$('#contactForm textarea[name=cinquiryContent]').css('border','1px solid rgba(0,0,0,.15)');
            $('.error-msg[data-error-of="cinquiryContent"]').fadeOut();
		} else{
			$('#contactForm textarea[name=cinquiryContent]').css('border','1px solid #fe2851');
            $('.error-msg[data-error-of="cinquiryContent"]').fadeIn();
		}
        
		if(errors > 0){
			e.preventDefault();
		}else{

			// here we test recaptcha on server side
			if($('#contactForm').find('.g-recaptcha').length){
        const data = {
          'action': 'check_recaptcha',
          'captcha': $('#contactForm').find('#g-recaptcha-response').val(),
          'nonce': $('#g-recaptcha').data('nonce')
        };
        $.ajax({
          type: 'POST',
          url: app_start_local_data.ajaxurl,
          data: data,
          success: function(response){
						if (response == 'true') {
								$('.g-recaptcha').closest(".form-group").find(".invalid-feedback").hide();
								$('.form-wrapper-js').addClass('form_loading');
							} 
							else {
								e.preventDefault();
								$('.g-recaptcha').closest(".form-group").find(".invalid-feedback").show().css('color', '#ff4b4b');
							}
						},
						async:false
					});
				}else{
					$('.form-wrapper-js').addClass('form_loading');
				}
		}
	});

	$('.inquery-input').keyup(function(){
		var name = $(this).attr('name');
		var value = $(this).val().trim();
		if(name === 'cfirstname' || name === 'clastname' || name === 'cinquiryContent'){
            if(value.length > 0){
                $(this).css('border','1px solid rgba(0,0,0,.15)');
                $('.error-msg[data-error-of="'+name+'"]').fadeOut();
            } else{
                $(this).css('border','1px solid #fe2851');
                $('.error-msg[data-error-of="'+name+'"]').fadeIn();
            }
		}
		else if(name === 'cemail'){
            if(isValidEmailAddress(value)){
                $(this).css('border','1px solid rgba(0,0,0,.15)');
                $('.error-msg[data-error-of="'+name+'"]').fadeOut();
            } else{
                $(this).css('border','1px solid #fe2851');
                $('.error-msg[data-error-of="'+name+'"]').fadeIn();
            }
		}
	});

	

}(jQuery)); 

function goBack() {
    window.history.back();
}

